import { Box, TextField } from '@mui/material';
import { ITextAttribute } from '../../../Interfaces/ILegalTransactionMeasure';

export const TextAttribute = ({
  attribute,
  onUpdateAttribute,
}: {
  attribute: ITextAttribute;
  onUpdateAttribute: (attribute: ITextAttribute) => void;
}) => {
  return (
    <Box>
      <TextField
        sx={{ minWidth: '300px', backgroundColor: 'background.paper' }}
        size='small'
        fullWidth
        label={attribute.Name}
        value={attribute.Value}
        required={attribute.Required}
        onChange={e =>
          onUpdateAttribute({ ...attribute, Value: e.target.value })
        }
      />
    </Box>
  );
};
